import script from "./NewModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewModal.vue?vue&type=script&setup=true&lang=ts"

import "./NewModal.vue?vue&type=style&index=0&id=d0b23954&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0b23954"]])

export default __exports__